/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalOfficeListing_requestGetPortalOfficeListing } from '../models/api_portalOfficeListing_requestGetPortalOfficeListing';
import type { api_portalOfficeListing_requestGetPortalOfficeListingGroupByListingStatus } from '../models/api_portalOfficeListing_requestGetPortalOfficeListingGroupByListingStatus';
import type { api_portalOfficeListing_requestGetPortalOfficeListingPublic } from '../models/api_portalOfficeListing_requestGetPortalOfficeListingPublic';
import type { api_portalOfficeListing_requestGetPortalOfficeListingPublicForNonMember } from '../models/api_portalOfficeListing_requestGetPortalOfficeListingPublicForNonMember';
import type { api_portalOfficeListing_requestSavePortalOfficeListing } from '../models/api_portalOfficeListing_requestSavePortalOfficeListing';
import type { api_portalOfficeListing_requestSearchPortalOfficeListings } from '../models/api_portalOfficeListing_requestSearchPortalOfficeListings';
import type { api_portalOfficeListing_requestSearchPortalOfficeListingsForNonMember } from '../models/api_portalOfficeListing_requestSearchPortalOfficeListingsForNonMember';
import type { api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngine } from '../models/api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngine';
import type { api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngineForNonMember } from '../models/api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngineForNonMember';
import type { api_portalOfficeListing_requestUpdatePortalOfficeListingPublishedAt } from '../models/api_portalOfficeListing_requestUpdatePortalOfficeListingPublishedAt';
import type { api_portalOfficeListing_requestUploadImportantDocument } from '../models/api_portalOfficeListing_requestUploadImportantDocument';
import type { api_portalOfficeListing_responseGetPortalOfficeListing } from '../models/api_portalOfficeListing_responseGetPortalOfficeListing';
import type { api_portalOfficeListing_responseGetPortalOfficeListingGroupByListingStatus } from '../models/api_portalOfficeListing_responseGetPortalOfficeListingGroupByListingStatus';
import type { api_portalOfficeListing_responseGetPortalOfficeListingPublic } from '../models/api_portalOfficeListing_responseGetPortalOfficeListingPublic';
import type { api_portalOfficeListing_responseGetPortalOfficeListingPublicForNonMember } from '../models/api_portalOfficeListing_responseGetPortalOfficeListingPublicForNonMember';
import type { api_portalOfficeListing_responseGetPortalOfficeListingSearchFilters } from '../models/api_portalOfficeListing_responseGetPortalOfficeListingSearchFilters';
import type { api_portalOfficeListing_responseSavePortalOfficeListing } from '../models/api_portalOfficeListing_responseSavePortalOfficeListing';
import type { api_portalOfficeListing_responseSearchPortalOfficeListings } from '../models/api_portalOfficeListing_responseSearchPortalOfficeListings';
import type { api_portalOfficeListing_responseSearchPortalOfficeListingsForNonMember } from '../models/api_portalOfficeListing_responseSearchPortalOfficeListingsForNonMember';
import type { api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngine } from '../models/api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngine';
import type { api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngineForNonMember } from '../models/api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngineForNonMember';
import type { api_portalOfficeListing_responseUpdatePortalOfficeListingPublishedAt } from '../models/api_portalOfficeListing_responseUpdatePortalOfficeListingPublishedAt';
import type { api_portalOfficeListing_responseUploadImportantDocument } from '../models/api_portalOfficeListing_responseUploadImportantDocument';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalOfficeListingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get PortalOfficeListing
     * Get PortalOfficeListing ※非公開の掲載情報も取得するため、PortalStaffからCallする事
     * @returns api_portalOfficeListing_responseGetPortalOfficeListing responseGetPortalOfficeListing
     * @throws ApiError
     */
    public postPortalOfficeListingGet({
        body,
    }: {
        /**
         * requestGetPortalOfficeListing
         */
        body: api_portalOfficeListing_requestGetPortalOfficeListing,
    }): CancelablePromise<api_portalOfficeListing_responseGetPortalOfficeListing> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Public PortalOfficeListing by PortalOfficeId
     * Get PortalOfficeListing 公開中の掲載情報を1件取得する
     * @returns api_portalOfficeListing_responseGetPortalOfficeListingPublic responseGetPortalOfficeListingPublic
     * @throws ApiError
     */
    public postPortalOfficeListingGetPublic({
        body,
    }: {
        /**
         * requestGetPortalOfficeListingPublic
         */
        body: api_portalOfficeListing_requestGetPortalOfficeListingPublic,
    }): CancelablePromise<api_portalOfficeListing_responseGetPortalOfficeListingPublic> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/get_public',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Public PortalOfficeListing for Non-members by PortalOfficeId
     * 非会員用に、公開中の掲載情報を1件取得する
     * @returns api_portalOfficeListing_responseGetPortalOfficeListingPublicForNonMember responseGetPortalOfficeListingPublicForNonMember
     * @throws ApiError
     */
    public postPortalOfficeListingGetPublicForNonMember({
        body,
    }: {
        /**
         * requestGetPortalOfficeListingPublicForNonMember
         */
        body: api_portalOfficeListing_requestGetPortalOfficeListingPublicForNonMember,
    }): CancelablePromise<api_portalOfficeListing_responseGetPortalOfficeListingPublicForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/get_public_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Search filter from schedule-engine
     * schedule-engineからfilterの一覧を取得するAPI
     * @returns api_portalOfficeListing_responseGetPortalOfficeListingSearchFilters responseGetPortalOfficeListingSearchFilters
     * @throws ApiError
     */
    public postPortalOfficeListingGetSearchFilter(): CancelablePromise<api_portalOfficeListing_responseGetPortalOfficeListingSearchFilters> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/get_search_filter',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Search filters
     * 非会員用に、看護ステーション掲載情報の検索条件を取得する
     * @returns api_portalOfficeListing_responseGetPortalOfficeListingSearchFilters responseGetPortalOfficeListingSearchFilters
     * @throws ApiError
     */
    public postPortalOfficeListingGetSearchFilterForNonMember(): CancelablePromise<api_portalOfficeListing_responseGetPortalOfficeListingSearchFilters> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/get_search_filter_for_non_member',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Portal Office Listing Published Date
     * Updates the published date of a portal office listing to the current time
     * @returns api_portalOfficeListing_responseUpdatePortalOfficeListingPublishedAt Successful response
     * @throws ApiError
     */
    public postPortalOfficeListingPublish({
        body,
    }: {
        /**
         * requestUpdatePortalOfficeListingPublishedAt
         */
        body: api_portalOfficeListing_requestUpdatePortalOfficeListingPublishedAt,
    }): CancelablePromise<api_portalOfficeListing_responseUpdatePortalOfficeListingPublishedAt> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/publish',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Portal Office Listing Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save PortalOfficeListing
     * Save PortalOfficeListing（id=nullでInsert、id指定でUpdate）
     * @returns api_portalOfficeListing_responseSavePortalOfficeListing responseSavePortalOfficeListing
     * @throws ApiError
     */
    public postPortalOfficeListingSave({
        body,
    }: {
        /**
         * requestSavePortalOfficeListing
         */
        body: api_portalOfficeListing_requestSavePortalOfficeListing,
    }): CancelablePromise<api_portalOfficeListing_responseSavePortalOfficeListing> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload Important Document(PDF、jpeg、png、doc、ppt、xls)
     * 重要事項ファイル(PDF、jpeg、png、doc、ppt、xls)をアップロードする
     * @returns api_portalOfficeListing_responseUploadImportantDocument responseUploadImportantDocument
     * @throws ApiError
     */
    public postPortalOfficeListingUploadImportantDocument({
        body,
    }: {
        /**
         * requestUploadImportantDocument
         */
        body: api_portalOfficeListing_requestUploadImportantDocument,
    }): CancelablePromise<api_portalOfficeListing_responseUploadImportantDocument> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listing/upload_important_document',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `ウイルススキャン失敗`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalOfficeListing
     * Get PortalOfficeListing
     * @returns api_portalOfficeListing_responseGetPortalOfficeListingGroupByListingStatus responseGetPortalOfficeListingGroupByListingStatus
     * @throws ApiError
     */
    public postPortalOfficeListingsGetGroupByListingStatus({
        body,
    }: {
        /**
         * requestGetPortalOfficeListingGroupByListingStatus
         */
        body: api_portalOfficeListing_requestGetPortalOfficeListingGroupByListingStatus,
    }): CancelablePromise<api_portalOfficeListing_responseGetPortalOfficeListingGroupByListingStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listings/get_group_by_listing_status',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeListing
     * Search PortalOfficeListing
     * @returns api_portalOfficeListing_responseSearchPortalOfficeListings responseSearchPortalOfficeListings
     * @throws ApiError
     */
    public postPortalOfficeListingsSearch({
        body,
    }: {
        /**
         * requestSearchPortalOfficeListings
         */
        body: api_portalOfficeListing_requestSearchPortalOfficeListings,
    }): CancelablePromise<api_portalOfficeListing_responseSearchPortalOfficeListings> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listings/search',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeListing use rest-schedule-engine
     * Search PortalOfficeListing (検索エンジンをコールして事業所を検索する)
     * @returns api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngine responseSearchPortalOfficeListingsUseEngine
     * @throws ApiError
     */
    public postPortalOfficeListingsSearchEngine({
        body,
    }: {
        /**
         * requestSearchPortalOfficeListingsUseEngine
         */
        body: api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngine,
    }): CancelablePromise<api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngine> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listings/search_engine',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeListing use rest-schedule-engine for Non-members
     * 非会員用に、検索エンジンをコールして掲載情報を検索する
     * @returns api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngineForNonMember responseSearchPortalOfficeListingsUseEngineForNonMember
     * @throws ApiError
     */
    public postPortalOfficeListingsSearchEngineForNonMember({
        body,
    }: {
        /**
         * requestSearchPortalOfficeListingsUseEngineForNonMember
         */
        body: api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngineForNonMember,
    }): CancelablePromise<api_portalOfficeListing_responseSearchPortalOfficeListingsUseEngineForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listings/search_engine_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOfficeListing for Non-members
     * 非会員用に、掲載情報を事業所名で検索する
     * @returns api_portalOfficeListing_responseSearchPortalOfficeListingsForNonMember responseSearchPortalOfficeListingsForNonMember
     * @throws ApiError
     */
    public postPortalOfficeListingsSearchForNonMember({
        body,
    }: {
        /**
         * requestSearchPortalOfficeListingsForNonMember
         */
        body: api_portalOfficeListing_requestSearchPortalOfficeListingsForNonMember,
    }): CancelablePromise<api_portalOfficeListing_responseSearchPortalOfficeListingsForNonMember> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_listings/search_for_non_member',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
